/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type HealthFragment = { __typename: "Health"; isAvailable: boolean }

export const HealthFragmentDoc = gql`
  fragment Health on Health {
    isAvailable
  }
`
